import React, { useEffect, lazy, Suspense } from 'react'
import "./Vender.js"
import { Helmet } from 'react-helmet-async';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery';
import { BrowserRouter as Router, Route, Routes, useLocation, Outlet } from 'react-router-dom'

import Footer from './Layout/Footer/Footer.js';
import HomePage from './defaultPages/HomePage.js'
// import Login from './defaultPages/Login/Login.js'
import Login from './Pages/Public/Login.js';

import PasswordReset from './Pages/Public/PasswordReset.js';

import ForgotPassword from './Pages/Public/ForgotPassword.js';


import TermsConditions from './Pages/Utilities/T&CPage.js';
import Maintenance from './Pages/Utilities/MaintanancePage.js';
import ComingSoon from './Pages/Utilities/ComingSoon.js';
import Error404 from './Pages/Utilities/Error404.js';
import Error404WithoutHeaderFooter from './Componet/NotDefinedPage.js';
import CatchAllRouter from './Pages/Utilities/CatchAllRouter.js';

import Inspector from './Pages/Public/Inspector/Inspector.js';

import Quotation from './Pages/Public/Quotation/Quotation.js';
import OrderComplete from './Pages/Public/Quotation/OrderComplete.js';
import Callback from './Pages/Public/callback.js';
import InspectorReport from './Pages/Protected/Inspector/Profile/InspectorReport.js';

import Payout from './Pages/Protected/Inspector/Payout.js';
import Support from './Pages/Protected/Inspector/Support.js';
import Training from './Pages/Protected/Inspector/Training.js';
import Workhub from './Pages/Protected/Inspector/Workhub.js';
import PrivateRoute from './PrivateRoute.js';
import HeaderPrivate from './Layout/Header/Private/HeaderPrivate.js';



import Header from './Layout/Header/Header.js';
import BlogListing from './Pages/Blog/BlogListing.js';
import Contact from './Pages/Public/Contact.js';

import AboutUs from './defaultPages/AboutUs.js';


import TrainingDetail from './Pages/Protected/Inspector/TrainingDetail.js';

import PrivateRoutes from './PrivateRoutes.js';
import Logout from './Pages/Public/logout.js';


import { SpinnerProvider } from './context/SpinnerContext.js';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';


import OrderList from './Pages/Protected/Admin/OrderList.js';
import Unauthorized from './defaultPages/ComingSoon/Unauthorized.js';

import { Roles } from './store/Utility/Utility.js';
import usePageTracking from './usePageTracking.js';
import BlogDetail from './Pages/Blog/BlogDetail.js';
import AwaitingInspectorList from './Pages/Protected/Employee/AwaitingInspectorList.js';

import LazyWrapper from './LazyWrapper.js';
import Transaction from './Pages/Protected/Admin/Transaction/Transaction.js';

import CoverageState from './Pages/Public/CoverageState.js';
import CoverageCity from './Pages/Public/CoverageCity.js';
import OrderTracking from './Pages/Public/Customer/OrderTracking.js';
import SsnConfiguration from './Pages/Protected/Inspector/Profile/SsnConfiguration.js';

// import CarOrder from './Pages/Protected/Admin/Order/CarOrder.js';
const CarOrder = lazy(() => import('./Pages/Protected/Admin/Order/CarOrder.js'));
// import MotorcycleOrder from './Pages/Protected/Admin/Order/MotorcycleOrder.js';
const MotorcycleOrder = lazy(() => import('./Pages/Protected/Admin/Order/MotorcycleOrder.js'));
// import CommercialOrder from './Pages/Protected/Admin/Order/CommercialOrder.js';
const CommercialOrder = lazy(() => import('./Pages/Protected/Admin/Order/CommercialOrder.js'));
// import RVOrder from './Pages/Protected/Admin/Order/RVOrder.js';
const RVOrder = lazy(() => import('./Pages/Protected/Admin/Order/RVOrder.js'));
// import CarfaxReport from './Pages/Protected/Admin/Order/CarfaxReport.js';
const CarfaxReport = lazy(() => import('./Pages/Protected/Admin/Order/CarfaxReport.js'));
// import OfferedInspector from './Pages/Protected/Admin/Order/OfferedInspector.js';
const OfferedInspector = lazy(() => import('./Pages/Protected/Admin/Order/OfferedInspector.js'));
// import HowItWorks from './defaultPages/ComingSoon/HowItWorks.js';
const HowItWorks = lazy(() => import('./defaultPages/ComingSoon/HowItWorks.js'));

// import CarInspection from './Pages/Protected/Inspector/Workhub/Inspection/CarInspection.js';
const CarInspection = lazy(() => import('./Pages/Protected/Inspector/Workhub/Inspection/CarInspection.js'));
// import MotorcycleInspection from './Pages/Protected/Inspector/Workhub/Inspection/MotorcycleInspection.js';
const MotorcycleInspection = lazy(() => import('./Pages/Protected/Inspector/Workhub/Inspection/MotorcycleInspection.js'));
// import CommercialInspection from './Pages/Protected/Inspector/Workhub/Inspection/CommercialInspection.js';
const CommercialInspection = lazy(() => import('./Pages/Protected/Inspector/Workhub/Inspection/CommercialInspection.js'));
// import RVInspection from './Pages/Protected/Inspector/Workhub/Inspection/RVInspection.js';
const RVInspection = lazy(() => import('./Pages/Protected/Inspector/Workhub/Inspection/RVInspection.js'));
// import InspectionReport from './Pages/Public/Customer/InspectionReport.js';
const InspectionReport = lazy(() => import('./Pages/Public/Customer/InspectionReport.js'));

// import InspectorSearch from './Pages/Protected/Admin/Management/Inspector/InspectorSearch.js';
const InspectorSearch = lazy(() => import('./Pages/Protected/Admin/Management/Inspector/InspectorSearch.js'));
// import InspectorPayment from './Pages/Protected/Admin/Management/Inspector/InspectorPayment.js';
const InspectorPayment = lazy(() => import('./Pages/Protected/Admin/Management/Inspector/InspectorPayment.js'));

// import ConfirmInspector from './Pages/Public/Inspector/ConfirmInspector.js';
const ConfirmInspector = lazy(() => import('./Pages/Public/Inspector/ConfirmInspector.js'));
// import FAQs from './Pages/Protected/Inspector/FAQ.js';
const FAQs = lazy(() => import('./Pages/Protected/Inspector/FAQ.js'));

// import FAQPublic from './Pages/Public/Faq.js';
const FAQPublic = lazy(() => import('./Pages/Public/Faq.js'));

// import PrivacyPolicy from './Pages/Utilities/Privacy.js';
const PrivacyPolicy = lazy(() => import('./Pages/Utilities/Privacy.js'));

// import Profile from './Pages/Protected/Inspector/Profile/Profile.js';
const Profile = lazy(() => import('./Pages/Protected/Inspector/Profile/Profile.js'));

// import Stats from './Pages/Protected/Inspector/Profile/Stats.js';
const Stats = lazy(() => import('./Pages/Protected/Inspector/Profile/Stats.js'));

// import Coverage from './Pages/Public/Coverage.js';
const Coverage = lazy(() => import('./Pages/Public/Coverage.js'));

// import Dashboard from './Pages/Protected/Inspector/Dashboard.js';
// import CompletedJobs from './Pages/Protected/Inspector/Workhub/CompletedJobs.js';
// import QueuedJobs from './Pages/Protected/Inspector/Workhub/QueuedJobs.js';
// import SearchJobs from './Pages/Protected/Inspector/Workhub/SearchJobs.js';
// import InspectorList from './Pages/Protected/Admin/InspectorList.js';
// import InspectorDetail from './Pages/Protected/Admin/InspectorDetail.js';
const Dashboard = lazy(() => import('./Pages/Protected/Inspector/Dashboard.js'));
const CompletedJobs = lazy(() => import('./Pages/Protected/Inspector/Workhub/CompletedJobs.js'));
const QueuedJobs = lazy(() => import('./Pages/Protected/Inspector/Workhub/QueuedJobs.js'));
const SearchJobs = lazy(() => import('./Pages/Protected/Inspector/Workhub/SearchJobs.js'));
const InspectorList = lazy(() => import('./Pages/Protected/Admin/InspectorList.js'));
const InspectorDetail = lazy(() => import('./Pages/Protected/Admin/InspectorDetail.js'));

const SampleReports = lazy(() => import('./Pages/Public/Reports/SampleReports.js'));
const ReportDetail = lazy(() => import('./Pages/Public/Reports/ReportDetail.js'));

function App() {
  const location = useLocation();
  usePageTracking();

  const getUrl = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/coming_soon'
      ? true
      : `/${pathArray[1]}` === '/maintenance'
        ? true
        : `/${pathArray[1]}` === '/error_404'
          ? true
          : `/${pathArray[1]}` === '*'
            ? true
            : false;
  };

  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const setHeader = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/index4' ? true : false;
  }

  const setFooter = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/index10' ? false : true;
  };
  const scrollbarStyle = `
  ::-webkit-scrollbar {
    display: none;
  }`;

  useEffect(() => {
    const handlePopstate = () => {
      window.location.reload(); // Refresh the page on popstate event (back button)
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, [location.pathname]);
  return (
    <>
      <Helmet>
        <title>Inspectiver | Pre-Purchase Car Inspection</title>
        <meta name="description" content="Inspectiver provides fast, on-site car inspections by ASE Certified techs. Get a detailed report and make smarter buying decisions with total confidence." />
        <meta name="keywords" content="pre purchase car inspection, pre-purchase car inspection, PPI, Vehicle Inspection, Used car inspection, mobile car inspection, Automative inspection, inspection, Car inspection, car inspection near me, Truck inspection, Motorcycle inspection, RV inspection, Auto inspection" />
        <link rel="canonical" href="https://www.inspectiver.com/" />
      </Helmet>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {getUrl(location.pathname) ?
        <Routes>
          <Route path="/coming_soon" element={<ComingSoon />} />
          <Route path="/error_404" element={<Error404 />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="*" element={<Outlet />}>
            {/* Render the Error404 component without Header and Footer */}
            <Route index element={<Error404WithoutHeaderFooter />} />
          </Route>
        </Routes> :

        <div className="page-wrapper">
          {/* {setHeader(location.pathname) ? <Header2 /> : <Header1 />} */}
          <Header />
          <SpinnerProvider>
            <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} >
              <Routes>
                {/* defaultHompage */}
                <Route path='/' element={<HomePage />} />
                <Route path='/Login' element={<Login />} />
                {/* <Route path='/Signup' element={<Signup />} /> */}
                <Route path='/about-us' element={<AboutUs />} />
                <Route path='/blog-list' element={<BlogListing />} />
                <Route path='/blog-detail/:id' element={<BlogDetail />} />
                {/* difaultHompage */}


                {/* NavbarHome */}

                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/reset-password' element={<PasswordReset />} />

                <Route path='/privacy-policy' element={<LazyWrapper><PrivacyPolicy /></LazyWrapper>} />
                <Route path='/terms_conditions' element={<TermsConditions />} />
                <Route path='/unauthorized' element={<Unauthorized />} />

                <Route path='/contact' element={<Contact />} />
                <Route path='/faqs' element={<LazyWrapper><FAQPublic /></LazyWrapper>} />

                <Route path='/logout' element={<Logout />} />

                <Route path='/sample-reports' element={<LazyWrapper><SampleReports /></LazyWrapper>} />
                <Route path='/sample-report/:id' element={<LazyWrapper><ReportDetail /></LazyWrapper>} />

                {/* <Route path='/Accordion' element={<AccordionPage />} /> */}
                {/* <Route path='/feature_box' element={<FeatureIconPage />} /> */}


                <Route path='/order-complete' element={<OrderComplete />} />

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.VehicleInspector]} />}>
                  <Route path='/profile' element={<LazyWrapper><Profile /></LazyWrapper>}></Route>
                  <Route path='/stats' element={<LazyWrapper><Stats /></LazyWrapper>}></Route>
                  <Route path='/my-report' element={<InspectorReport />}></Route>
                  <Route path='/settings/ssn' element={<SsnConfiguration />}></Route>
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin]} />}>
                  <Route path='/orders' element={<OrderList />} />
                  <Route path='/transactions' element={<Transaction />} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.EmployeeAdmin]} />}>
                  <Route path='/inspector-list/:filter?' element={<LazyWrapper><InspectorList /></LazyWrapper>} />
                  <Route path='/inspector/detail/:id/:filter?' element={<LazyWrapper><InspectorDetail /></LazyWrapper>} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin]} />}>
                  <Route path='/inspector-search' element={<LazyWrapper><InspectorSearch /></LazyWrapper>} />
                  <Route path='/inspector/payment/:id' element={<LazyWrapper><InspectorPayment /></LazyWrapper>} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.EmployeeAdmin, Roles.Employee, Roles.VehicleInspector]} />}>
                  <Route path='/dashboard' element={<LazyWrapper><Dashboard /></LazyWrapper>} />
                </Route>

                <Route path='/inspector' element={<Inspector />} />
                <Route path='/confirm-inspector' element={<LazyWrapper><ConfirmInspector /></LazyWrapper>} />
                <Route path='/quotation' element={<Quotation />} />
                <Route path='/order-complete' element={<OrderComplete />} />
                <Route path="/callback" element={<Callback />} />
                <Route path='/report/:reportId' element={<LazyWrapper><InspectionReport /></LazyWrapper>} />
                <Route path='/report' element={<LazyWrapper><InspectionReport /></LazyWrapper>} />
                <Route path='/how-it-works' element={<LazyWrapper><HowItWorks /></LazyWrapper>} />
                <Route path="/coverage" element={<LazyWrapper><Coverage /></LazyWrapper>}></Route>
                <Route path="/coverage/:state" element={<CoverageState />}></Route>
                <Route path="/coverage/:state/:city" element={<CoverageCity />}></Route>
                <Route path="/order-tracking/:key" element={<OrderTracking />} />

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.EmployeeAdmin, Roles.Employee]} />}>
                  {/* <Route path="/workhub" element={<Workhub />} /> */}
                  <Route path="/payout" element={<Payout />} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.EmployeeAdmin, Roles.Employee, Roles.VehicleInspector]} />}>
                  <Route path="/inspector-faqs" element={<LazyWrapper><FAQs /></LazyWrapper>} />
                  <Route path="/training" element={<Training />} />
                  <Route path="/training/:id" element={<TrainingDetail />} />
                  <Route path="/help" element={<Support />} />
                  {/* <Route path="/support" element={<Support />} /> */}
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.VehicleInspector, Roles.EmployeeAdmin, Roles.Employee]} />}>
                  <Route path="/workhub" element={<Workhub />} />
                  <Route path="/workhub/completed" element={<LazyWrapper><CompletedJobs /></LazyWrapper>} />
                  <Route path="/workhub/queued" element={<LazyWrapper><QueuedJobs /></LazyWrapper>} />
                  <Route path="/workhub/search" element={<LazyWrapper><SearchJobs /></LazyWrapper>} />
                  <Route path='/workhub/inspection/car/:id' element={<LazyWrapper><CarInspection /></LazyWrapper>} />
                  <Route path='/workhub/inspection/motorcycle/:id' element={<LazyWrapper><MotorcycleInspection /></LazyWrapper>} />
                  <Route path='/workhub/inspection/commercial/:id' element={<LazyWrapper><CommercialInspection /></LazyWrapper>} />
                  <Route path='/workhub/inspection/rv/:id' element={<LazyWrapper><RVInspection /></LazyWrapper>} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.EmployeeAdmin]} />}>
                  <Route path='/orders/car/:id' element={<LazyWrapper><CarOrder /></LazyWrapper>} />
                  <Route path='/orders/motorcycle/:id' element={<LazyWrapper><MotorcycleOrder /></LazyWrapper>} />
                  <Route path='/orders/commercial/:id' element={<LazyWrapper><CommercialOrder /></LazyWrapper>} />
                  <Route path='/orders/rv/:id' element={<LazyWrapper><RVOrder /></LazyWrapper>} />
                  <Route path='/orders/carfax/:id' element={<LazyWrapper><CarfaxReport /></LazyWrapper>} />
                  <Route path='/orders/offered/:id' element={<LazyWrapper><OfferedInspector /></LazyWrapper>} />
                </Route>

                <Route element={<PrivateRoutes allowedRoles={[Roles.Admin, Roles.Employee]} />}>
                  <Route path='/awaiting-inspector' element={<AwaitingInspectorList />} />
                </Route>

                <Route path="*" element={<CatchAllRouter />} />

                {/* Company */}
              </Routes>
            </GoogleReCaptchaProvider>
          </SpinnerProvider>
          <Footer />
        </div>
      }
    </>
  )
}

export default App

